import React from 'react';
import PropTypes from 'prop-types';
import { StyledNotifications } from './style';

const Notifications = ({ numberNot, className }) => (
  <StyledNotifications className={className}>{numberNot}</StyledNotifications>
);

Notifications.propTypes = {
  numberNot: PropTypes.string,
  className: PropTypes.string
};

Notifications.defaultProps = {};

export default Notifications;
